import { Link } from "react-router-dom";
import React from "react";
import { Grid, Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import Typography from "@mui/material/Typography";

import classes from "./MainPage.module.css";
import background from "../img/mainpage_photo.svg";
import WhiteBtn from "../components/button/WhiteBtn";
import GrayBtn from "../components/button/GrayBtn";

import "../Firebase";
import { signInWithGoogle } from "../services/LoginService";

function MainPage() {
  return (
    <Box className={classes.mainpage}>
      <Grid container className={classes.mainpage_upper}>
        <Grid item xs={12} md={6} className={classes.leftside}>
          <Box contaioner direction="column">
            <Grid className={classes.title}>
              <h1 className={classes.w300}>
                歡迎來到
                <br />
                StartUpSpeedUp!
              </h1>
            </Grid>
            <Grid className={classes.subtitle}>
              <h3 className={classes.w300}>
                最好的加速器，為您量身定做最適合您的創業夥伴！
              </h3>
            </Grid>
          </Box>
          <div>
            <div>
              <GrayBtn
                onClick={() => {
                  signInWithGoogle();
                }}
                variant="h5"
                className={classes.leftbutton}
              >
                登入挑戰
              </GrayBtn>
            </div>
            <div>
              <Link to="/explore-1">
                <WhiteBtn variant="h5" className={classes.MainBtn}>
                  探索創業
                </WhiteBtn>
              </Link>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <img
            className={classes.mainpage_photo}
            src={background}
            alt="mainpage"
          />
        </Grid>
        <Grid item xs={12} className={classes.mainpage_footer_wordbox}>
          <a
            className={classes.mainpage_footer_word}
            href="https://forms.gle/kUckCKT2dUPU65zf7"
          >
            <Typography variant="h8" className={classes.w300}>
              報修表單
            </Typography>
          </a>
          <div className={classes.blank} />
          <div>
            <Link to="/ideapool">
              <Typography variant="h8" className={classes.w300}>
                點子池
              </Typography>
            </Link>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
}

export default observer(MainPage);
